<template>
  <div style="background-color: #F5F7FA;height: 100%;">
    <div style="padding: 0px;position: relative;">
        <div v-show="isShow"  class="hint">
          定位中,请等待。。。
        </div>
        <baidu-map
            class="map"
            :center="center"
            :zoom="zoom"
            @ready="handler"
            :scroll-wheel-zoom="true"
            :mapClick="false">
          <bm-marker
              :position="{lng: center.lng, lat: center.lat }"
              :dragging="true"
              animation="BMAP_ANIMATION_BOUNCE">
          </bm-marker>
        </baidu-map>
      </div>
    </div>
</template>

<script>


import {timeStr} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";
import {getStaffCode} from "@/utils/auth";

export default {
  name: "addHospital",
  data() {
    return {
      isShow:true,
      userDeviceCode: '',
      center: {
        lng: 0,
        lat: 0
      },
      zoom: '',

      dingweiNumber:0,

    };
  },
  components: {},
  methods: {
    init(userDeviceCode) {
      this.userDeviceCode = userDeviceCode;

      this.isShow=true;

      this.getlocatiom();

    },
    closeSelf() {
      this.$emit('closeBaiduMapReal')
    },
    handler({BMap, map}) {
      console.log(BMap, map)
      this.center.lng = 116.404;
      this.center.lat = 39.915;
      this.zoom = 15
    },

    getElderly() {

      this.$axios({
        method: 'post',
        url: this.$deviceUrl + "Positioning/PositioningForElderly",
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
          staffCode: getStaffCode(),
          userDeviceCode: this.userDeviceCode
        }
      }).then((response) => {
            if (response.data.error === 0) {
              this.isShow=false;
              this.center.lng = response.data.data.lon;
              this.center.lat = response.data.data.lat;
            } else if (response.data.error === 1) {
              this.isShow=false;
              this.$message.error(response.data.message)
            } else {
              this.isShow=false;
              this.$message({type: 'info', message: '定位失败'});
            }
          })

    },


    getlocatiom(){
      this.dingweiNumber = 0;
      this.getlocatiom2();
    },

    getlocatiom2(){

      let that = this;

      this.$axios({
        method: 'post',
        url: this.$deviceUrl+'DeviceXiaodou/Positioning2',
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          userDeviceCode:this.userDeviceCode
        }
      }).then((response)=> {

        if(response.data.error == 0){

          this.isShow=false;
          var data=response.data.data

          let dd = this.bd_encrypta(data.lon,data.lat);

          this.center.lng = dd[0];
          this.center.lat = dd[1];


        }else if(response.data.error == 1){
          this.$message({type: 'error', message: response.data.message});
        }

      }).catch(function (error) {
        console.log(error);

        that.dingweiNumber++;
        if(that.dingweiNumber<3){
          that.getlocatiom2();
        }else{
          that.$message({type: 'error', message:'定位失败'});
        }


      });

    },




    // GCJ-02 to BD-09
    bd_encrypta(gg_lon, gg_lat) {
      var X_PI = Math.PI * 3000.0 / 180.0;
      var x = gg_lon, y = gg_lat;
      var z = Math.sqrt(x * x + y * y) + 0.00002 * Math.sin(y * X_PI);
      var theta = Math.atan2(y, x) + 0.000003 * Math.cos(x * X_PI);
      var bd_lon = z * Math.cos(theta) + 0.0065;
      var bd_lat = z * Math.sin(theta) + 0.006;
      return [bd_lon, bd_lat]
    },

    // BD-09 to GCJ-02
    bMapTransWXMap(lng, lat) {
      let x_pi = 3.14159265358979324 * 3000.0 / 180.0;
      let x = lng - 0.0065;
      let y = lat - 0.006;
      let z = Math.sqrt(x * x + y * y) - 0.00002 * Math.sin(y * x_pi);
      let theta = Math.atan2(y, x) - 0.000003 * Math.cos(x * x_pi);
      let lngs = z * Math.cos(theta);
      let lats = z * Math.sin(theta);
      return [lngs, lats]
    },



  }
};

</script>

<style>

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}

input[type="number"] {
  -moz-appearance: textfield;
}


</style>


<style lang="scss" scoped>
.map {
  width: 100%;
  height: 380px;
}
.hint{
  position: absolute;
  z-index: 1000;
  color: red;
  font-size: 20px;
  margin: 10px;
}



</style>
